__turbopack_context__.v({
  "baseProductImageContainer": "styles-module__2m_6sq__baseProductImageContainer",
  "borderRadiusLg": "styles-module__2m_6sq__borderRadiusLg",
  "borderRadiusMd": "styles-module__2m_6sq__borderRadiusMd",
  "hoverOverlay": "styles-module__2m_6sq__hoverOverlay",
  "overlay": "styles-module__2m_6sq__overlay",
  "placeholder": "styles-module__2m_6sq__placeholder",
  "portrait": "styles-module__2m_6sq__portrait",
  "productCardRoot": "styles-module__2m_6sq__productCardRoot",
  "productImageContainer": "styles-module__2m_6sq__productImageContainer",
  "productImageContainer__withHoverOverlay": "styles-module__2m_6sq__productImageContainer__withHoverOverlay" + " " + "styles-module__2m_6sq__baseProductImageContainer",
  "productImageContainer__withoutHoverOverlay": "styles-module__2m_6sq__productImageContainer__withoutHoverOverlay" + " " + "styles-module__2m_6sq__baseProductImageContainer",
  "square": "styles-module__2m_6sq__square",
});
